import React, { useState } from "react";
import { Link } from "react-router-dom";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import { MenuModal } from "../../../partials";
import { usePageData, useTheme } from "../../core";
import { MenuInner } from "./MenuInner";
import { Topbar } from "./Topbar";
import { useLocation } from "react-router";
import { usePDFExport } from "../../../../hooks/usePDFExport";

export function Header() {
  const location = useLocation();
  const state = location.state as { projectTitle?: string; projectID?: string; projectDescription?: string; userID?: string } | null;
  const projectTitle = state?.projectTitle ?? 'Default Project Title';
  const projectID = state?.projectID ?? 'Default Project ID';
  const projectDescription = state?.projectDescription ?? '';
  const userID = state?.userID ?? 'Default User ID';

  const [showMegaMenuModal, setShowMegaMenuModal] = useState(false);
  const { config, classes, attributes } = useTheme();
  const { pageTitle, moduleName } = usePageData();
  const { exportPDF, isExporting } = usePDFExport();
  const { businessScore: overallScore } = usePageData();

  const getScoreColor = (score: number) => {
    if (score >= 60) return "success";
    if (score >= 40) return "warning";
    return "danger";
  };

  return (
    <>
      <div
        className={`${classes.headerContainer.join(
          " "
        )} d-flex align-items-stretch justify-content-between`}
        {...Object.fromEntries(Array.from(attributes.headerContainer))}
      >
        {/* begin::Left */}
        <div className="d-flex align-items-center">
          {config.aside.content && config.aside.content === "menu" && (
            <>
              <h3 className="text-dark fw-bolder my-1 fs-1 me-4">{pageTitle}</h3>
              {state && (
                <Link
                  className="btn btn-sm btn-light-primary"
                  to="/project-details"
                  state={{ projectTitle, projectID, projectDescription, userID }}
                >
                  <i className="bi bi-pencil fs-7 me-1"></i>
                  Edit Details
                </Link>
              )}
            </>
          )}
          {config.aside.content && config.aside.content === "docs" && (
            <h3 className="text-dark fw-bolder my-1 fs-1">{pageTitle}</h3>
          )}
          {!config.aside.content && (
            <>
              {/* begin::Mega Menu Toggler
              <button
                className="btn btn-icon btn-accent me-2 me-lg-6"
                id="kt_mega_menu_toggle"
                onClick={() => setShowMegaMenuModal(true)}
              >
                <KTSVG
                  path="/media/icons/duotone/Text/Article.svg"
                  className="svg-icon-1"
                />
              </button> */}
              <Link
                to="/project"
                state={{
                  projectTitle: projectTitle,
                  projectID: projectID,
                  userID: userID
                }}
                className="btn btn-icon"
              >
                  <i className="bi bi-arrow-left-square-fill fs-4 me-2"></i>
              </Link>

              {/* end::Mega Menu Toggler */}

              {/* begin::Logo */}
              <Link to="/project"
                state={{
                  projectTitle: projectTitle,
                  projectID: projectID,
                  userID: userID
                }}>
                <h3 className="fs-5 fw-normal mb-0">Back to {projectTitle ? projectTitle : pageTitle} Dashboard</h3>
              </Link>
              {/* end::Logo */}
            </>
          )}
        </div>
        {/* end::Left */}

        {/* begin::Right */}
        {state && config.aside.content === "menu" && (
          <div className="d-flex align-items-center gap-2">
            {typeof overallScore === "number" && (
              <div
                className={`d-flex align-items-center badge badge-light-${getScoreColor(overallScore)} px-3 py-2 fs-7 cursor-pointer`}
                onClick={() => document.getElementById("business-score-widget")?.scrollIntoView({ behavior: "smooth" })}
                role="button"
              >
                <i className={`bi bi-shield-check me-1 text-${getScoreColor(overallScore)}`}></i>
                <span className="fw-bold">{overallScore}</span>
                <span className="fw-semibold ms-1 text-gray-600">/100</span>
              </div>
            )}
            <button
              className="btn btn-sm btn-light"
              onClick={() => exportPDF(projectID, projectTitle)}
              disabled={isExporting}
            >
              {isExporting ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Exporting...
                </>
              ) : (
                <>
                  <i className="bi bi-file-pdf fs-7 me-1"></i>
                  Export PDF
                </>
              )}
            </button>
            <Link
              className="btn btn-sm btn-light"
              to="/pitch-deck"
              state={{ projectTitle, projectID, projectDescription, userID }}
            >
              <i className="bi bi-easel fs-7 me-1"></i>
              Pitch Deck
            </Link>
          </div>
        )}
        {/* end::Right */}
      </div>
      <MenuModal
        show={showMegaMenuModal}
        handleClose={() => setShowMegaMenuModal(false)}
      >
        <MenuInner />
      </MenuModal>
    </>
  );
}
